import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import en from "./locales/en.json"
import tr from "./locales/tr.json"

i18n.use(initReactI18next).init({
  resources: {
    en,
    tr
  },
  lng: "tr",
  interpolation: {
    escapeValue: false // react already safes from xss
  }
})

export default i18n
